// NAVBAR component: fixed state header
//*******************************************************************
//dependencies
import $ from 'jquery'
import Popper from 'popper.js'
import React from 'react'
import {StaticQuery, graphql, Link} from 'gatsby'
//importing react-bootstrap nav component
import Navbar from 'react-bootstrap/Navbar'
//custom CSS file
import '../styles/stateheader.css'
import '../styles/global.css'
//*******************************************************************
//*******************************************************************
export default () => (
    <StaticQuery
        //prop one: dbquery
        query={graphql`
            query {
                allButterCollection(filter: { id: { eq: "external_navbar_links" } }) {
                    edges {
                        node {
                            id
                            value {
                                url,
                                label,
                            }
                        }
                    }
                }
                home: allButterPage(filter: { slug: { eq: "index" } }) {
                    edges {
                        node {
                            state_seal
                        }
                    }
                }
            }
        `}
      
        render={data => (
            <div class="backgroundColor">
				
                    <div class="container containerStateHeader">
                    
                        <img class="navbar-brand" id='stateSeal' src={data.home.edges[0].node.state_seal} alt="State of New Jersey Seal"/>   
                        
                        <a href='https://nj.gov/' target="_blank" rel="noopener" class='stateNavItem'>{data.allButterCollection.edges[0].node.value[8].label}</a>
                        
                    </div>
           
            </div>
        )}
  />
)
